module.exports = __webpack_public_path__ + "img/2.8fe0244f.png";